import Routes  from './routes'

import './styles/loader.scss'
import 'bootstrap/dist/css/bootstrap.css'

function App() {
  return ( <Routes/>) ;
}

export default App;
